/**
 * Used only when `pdfjsLib.version` is missing at runtime (should be rare).
 * Keep this equal to the **minimum** version allowed by `package.json`:
 * `dependencies["pdfjs-dist"]` — for `6.2.108`, use `6.2.108`.
 * When you bump that dependency, update this string so CDN asset URLs and
 * the worker script stay consistent if the runtime version is ever absent.
 */
export const PDFJS_DIST_FALLBACK_VERSION = "6.2.108";
